let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("doomh")).then(() => parcelRequire('f0syu'));